import React, {useState} from "react";

// STYLES
import styles from "../pages/insights/insights.module.scss";


const TabButtons = ({tab, index, activeTab, setActiveTab}) => {

    return (
        <button style={activeTab === index ? {backgroundColor: "#61189f"} : {backgroundColor: "#04aa6d"}}
                onClick={() => setActiveTab(index)}
        >
            {tab}
        </button>
    );
};

export default TabButtons;